// Cart stored in localStorage. Server-side persistence is optional.
const KEY = "vendora_cart";

export function getCart() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function saveCart(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("vendora-cart-changed"));
}

export function addToCart(product, quantity = 1) {
  const cart = getCart();
  const existing = cart.find((c) => c.product_id === product.id);
  if (existing) existing.quantity += quantity;
  else cart.push({ product_id: product.id, quantity, title: product.title, price: product.price, image: product.images?.[0] });
  saveCart(cart);
  return cart;
}

export function updateQty(productId, qty) {
  const cart = getCart().map((c) => c.product_id === productId ? { ...c, quantity: qty } : c).filter((c) => c.quantity > 0);
  saveCart(cart);
  return cart;
}

export function removeFromCart(productId) {
  saveCart(getCart().filter((c) => c.product_id !== productId));
}

export function clearCart() {
  saveCart([]);
}

export function cartTotals(cart) {
  const subtotal = cart.reduce((s, c) => s + c.price * c.quantity, 0);
  const tax = subtotal * 0.13;
  const shipping = subtotal >= 100 ? 0 : 9.99;
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    tax: Math.round(tax * 100) / 100,
    shipping,
    total: Math.round((subtotal + tax + shipping) * 100) / 100,
  };
}

export function formatCAD(n) {
  return new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(n || 0);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
  } catch { return iso; }
}

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  supplier: "Supplier",
  merchant: "Merchant",
  affiliate: "Affiliate",
  creator: "Creator",
  fulfillment_partner: "Fulfillment Partner",
  service_provider: "Service Provider",
  customer: "Customer",
};
